module.exports = __webpack_public_path__ + "img/carousel4.47a5992f.jpg";